import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { cn } from '../utils/cn';

// Menu superior global do Stela Guia — o nav da proposta aprovada, com TODAS as
// rotas do menu lateral (nenhuma rota/menu perdido). Grupos abrem em dropdown
// sólido do atlas; mobile empilha num painel único. Entrar → /members (rota existente).
type Item = { id: string; label: string; sub?: Array<{ id: string; label: string }> };

const NAV: Item[] = [
  { id: '/#previas', label: 'Ferramentas' },
  { id: '/#stela', label: 'Stela' },
  { id: '/#blog', label: 'Blog' },
  { id: '/#faq', label: 'Dúvidas' },
  { id: '/#pacotes', label: 'Pacotes' },
  {
    id: 'mais', label: 'Mais',
    sub: [
      { id: '/chart', label: 'Mapa Astral' },
      { id: '/chat', label: 'Chat' },
      { id: '/compatibility', label: 'Match' },
      { id: '/consultants', label: 'Consultores' },
      { id: '/rewards', label: 'Recompensas' },
      { id: '/referral', label: 'Indique e Ganhe' },
      { id: '/store', label: 'Loja' },
      { id: '/work', label: 'Trabalhe Conosco' },
      { id: '/members', label: 'Login de Membros' },
      { id: '/profile', label: 'Perfil' },
      { id: '/terms', label: 'Termos de Uso' },
      { id: '/privacy', label: 'Política de Privacidade' },
    ],
  },
];

export const StelaNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [open, setOpen] = useState<string | null>(null);
  const [mobile, setMobile] = useState(false);
  const barRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const close = (e: MouseEvent) => {
      if (!barRef.current?.contains(e.target as Node)) { setOpen(null); setMobile(false); }
    };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  const go = (id: string) => { navigate(id); setOpen(null); setMobile(false); };
  return (
    <div ref={barRef} className="sticky top-0 z-50 bg-stela-ink/95">
      <div className="max-w-[1060px] mx-auto px-[18px] hidden md:flex items-center gap-5 py-4">
        <Link to="/" className="flex items-center gap-2.5 font-display text-[20px] font-semibold text-stela-fg">
          <svg viewBox="0 0 24 24" className="w-[26px] h-[26px]" aria-hidden="true">
            <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4L12 2z" fill="url(#navstar)" />
            <defs><linearGradient id="navstar" x1="2" y1="2" x2="22" y2="22">
              <stop stopColor="#C4A5F5" /><stop offset="1" stopColor="#8B5CF6" /></linearGradient></defs>
          </svg>
          Stela Guia
        </Link>

        {NAV.map((item) => (
          <div key={item.id} className="relative">
            {item.sub ? (
              <button onClick={() => setOpen(open === item.id ? null : item.id)}
                className="text-[13.5px] transition-colors text-stela-muted hover:text-stela-lilac">
                {item.label}
              </button>
            ) : (
              <a href={item.id}
                className="text-[13.5px] transition-colors text-stela-muted hover:text-stela-lilac">
                {item.label}
              </a>
            )}
            {item.sub && open === item.id && (
              <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-stela-ink2 border border-stela-line rounded-[14px] py-2 min-w-[180px] shadow-[0_18px_44px_rgba(0,0,0,.5)]">
                {item.sub.map((sub) => (
                  <button key={sub.id} onClick={() => go(sub.id)}
                    className={cn('block w-full text-left px-4 py-2 text-[13.5px] hover:bg-white/5 transition-colors',
                      location.pathname === sub.id ? 'text-stela-lilac' : 'text-stela-muted hover:text-stela-lilac')}>
                    {sub.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}

        <a href={user ? '/profile' : '/members'} onClick={(e)=>{e.preventDefault(); navigate(user?'/profile':'/members');}}
          className="ml-auto px-5 py-2.5 border border-stela-line rounded-full text-stela-lilac text-[13.5px] transition-colors hover:border-stela-lilac/40">
          {user ? 'Perfil' : 'Entrar'}
        </a>
      </div>

      {/* mobile: logo + Menu (painel único com TODAS as rotas) */}
      <div className="flex md:hidden items-center justify-between px-[18px] py-3.5">
        <Link to="/" className="flex items-center gap-2 font-display text-lg text-stela-fg">
          <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true"><path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4L12 2z" fill="#C4A5F5" /></svg>
          Stela Guia
        </Link>
        <button onClick={() => setMobile(!mobile)} className="px-4 py-2.5 border border-stela-line rounded-full text-stela-lilac text-[13px]">
          {mobile ? 'Fechar' : 'Menu'}
        </button>
      </div>
      {mobile && (
        <div className="md:hidden bg-stela-ink2 border-y border-stela-line px-[18px] py-3">
          {NAV.map((item) => (
            <div key={item.id}>
              <button onClick={() => (item.sub ? go(item.sub[0].id) : go(item.id))}
                className="w-full text-left py-2.5 text-stela-fg text-body font-semibold">
                {item.label}
              </button>
              {item.sub && (
                <div className="pl-3 pb-1">
                  {item.sub.map((sub) => (
                    <button key={sub.id} onClick={() => go(sub.id)}
                      className={cn('block w-full text-left py-1.5 text-[13.5px]',
                        location.pathname === sub.id ? 'text-stela-lilac' : 'text-stela-muted')}>
                      {sub.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
          <button onClick={() => go(user ? '/profile' : '/members')} className="w-full mt-2 mb-1 px-5 py-3 border border-stela-line rounded-full text-stela-lilac text-body">
            {user ? 'Perfil' : 'Entrar'}
          </button>
        </div>
      )}
      <div className="h-px" aria-hidden="true">
        <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(190,160,255,.22), transparent)' }} />
      </div>
    </div>
  );
};